import { ChakraProvider, createToaster } from '@chakra-ui/react'
import { ThemeProvider } from 'next-themes'

import { Toaster } from '@/components/ui/toaster'
import { system } from '@/utils/theme'

export const toaster = createToaster({
    placement: 'bottom-end',
    pauseOnPageIdle: true,
})

export const Provider = (props: { children: React.ReactNode }) => {
    return (
        <ChakraProvider value={system}>
            <ThemeProvider attribute="class" disableTransitionOnChange defaultTheme="light">
                {props.children}
                <Toaster />
            </ThemeProvider>
        </ChakraProvider>
    )
}
